import { render, staticRenderFns } from "./TransactionConfirmPage.vue?vue&type=template&id=07da8891&scoped=true"
import script from "./TransactionConfirmPage.vue?vue&type=script&lang=js"
export * from "./TransactionConfirmPage.vue?vue&type=script&lang=js"
import style0 from "./TransactionConfirmPage.vue?vue&type=style&index=0&id=07da8891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da8891",
  null
  
)

export default component.exports